/** Публичный origin Document Server для браузера (без завершающего слэша). Без HTTP-fallback на cluster DNS. */
export function getR7DocumentServerUrl(): string {
  const raw = import.meta.env.VITE_R7_DOCUMENT_SERVER_URL
  if (raw == null || String(raw).trim() === '') {
    return ''
  }
  return String(raw).trim().replace(/\/+$/, '')
}

export function getR7DocumentServerApiScriptUrl(): string {
  const base = getR7DocumentServerUrl()
  if (!base) {
    throw new Error('Не задан VITE_R7_DOCUMENT_SERVER_URL: api.js Document Server не загружается')
  }
  return `${base}/web-apps/apps/api/documents/api.js`
}
